import { render, staticRenderFns } from "./viewQuotation.vue?vue&type=template&id=0896f106"
import script from "./viewQuotation.vue?vue&type=script&lang=js"
export * from "./viewQuotation.vue?vue&type=script&lang=js"
import style0 from "./viewQuotation.vue?vue&type=style&index=0&id=0896f106&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports